module.exports = __webpack_public_path__ + "img/icone-padaria.ea745d3c.svg";